import { EXTRACT_LAST_NUMBER_REGEX } from '@/constants/common';

import { ActivePaidService } from '../components/ExtraContent/ExtraContent.types';

export function extractTopUpAmount(service: ActivePaidService): number | null {
  if (!service) return null;

  if (typeof service === 'object') {
    return typeof service.price === 'number' ? service.price : null;
  }

  if (typeof service === 'string') {
    const match = service.match(EXTRACT_LAST_NUMBER_REGEX);
    const price = match && Number(match[1]);
    return price && !Number.isNaN(price) ? price : null;
  }

  return null;
}
